// @flow
import CardLayout, { cardLayoutTester } from './CardLayout';
import CardContentLayout, {
    cardContentLayoutTester
} from './CardContentLayout';
import FlexLayout, { flexLayoutTester } from './FlexLayout';

export const viewLayoutRenderers = [
    { renderer: CardLayout, tester: cardLayoutTester },
    { renderer: CardContentLayout, tester: cardContentLayoutTester },
    { renderer: FlexLayout, tester: flexLayoutTester }
];
